const baseURL = 'https://dcc-prdq.onrender.com/api';
export default baseURL;